import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessHeroComponent } from '../../Components/Business/business-hero/business-hero';
import { BusinessIndustriesComponent } from '../../Components/Business/business-industries/business-industries';
import { BusinessBenefitsComponent } from '../../Components/Business/business-benefits/business-benefits';
import { BusinessStoriesComponent } from '../../Components/Business/business-stories/business-stories';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-business-page',
  standalone: true,
  imports: [
    CommonModule,
    BusinessHeroComponent,
    BusinessIndustriesComponent,
    BusinessBenefitsComponent,
    BusinessStoriesComponent,
  ],
  templateUrl: './business-page.html',
})
export class BusinessPageComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Business Solutions for Every Industry',
      description:
        'One ERP platform shaped around how your business runs — retail, manufacturing, healthcare, education, and multi-branch operations.',
      path: '/business',
    });
  }
}
